import { InputText } from "primereact/inputtext";
import localeText from "../../../../locale";
import { Button } from "primereact/button";
import { useEffect, useRef, useState } from "react";
import IntegrationService from "../../../../service/IntegrationService";
import { Toast } from "primereact/toast";

const MetaAdsConfig = () => {
  const integrationsService = new IntegrationService();

  const [accessToken, setAccessToken] = useState("");
  const [pixelId, setPixelId] = useState("");
  const [loading, setLoading] = useState(false);

  const pixel = useRef(null);
  const toast = useRef(null);

  const accessTokenInput = useRef("accessTokenInput");
  const pixelIdInput = useRef("pixelIdInput");

  const extraconomyToken = localStorage.getItem("__extraconomy_token");

  const configPixel = async (facebook_access_token, facebook_pixel_id) => {
    if (accessToken === "" || pixelId === "") {
      toast.current.show({
        severity: "error",
        summary: localeText("fillInAllFields"),
      });

      return;
    }
    try {
      let res = await integrationsService.configPixel(
        facebook_access_token,
        facebook_pixel_id,
        extraconomyToken
      );
      toast.current.show({
        severity: "success",
        summary: localeText("pixelConfigSaved"),
        detail: localeText("pixelConfigSavedDetail"),
        life: 6000,
      });
      return res;
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: localeText("pixelConfigError"),
        detail: localeText("pixelConfigErrorDetail"),
        life: 6000,
      });
      console.log(err);
    }
  };
  useEffect(() => {
    let mounted = true;
    setLoading(true);
    const integration = new IntegrationService();
    async function getPixel() {
      let res = await integration.getPixel(extraconomyToken);
      pixel.current = res;
    }
    getPixel().then(() => {
      setLoading(false);
      if (
        mounted &&
        pixel.current?.result.facebook_access_token &&
        pixel.current?.result.facebook_pixel_id
      ) {
        setAccessToken(pixel.current.result.facebook_access_token);
        setPixelId(pixel.current.result.facebook_pixel_id);
      }
    });
    return () => {
      mounted = false;
    };
  }, [extraconomyToken]);

  return (
    <>
      <Toast ref={toast} />
      <div className="border-round" style={{ backgroundColor: "#46a748" }}>
        <h1 className="py-6 text-center text-0 lg:text-6xl md:text-6xl text-4xl">
          {localeText("metaAdsConfig")}
        </h1>
      </div>
      <div className="card border-300">
        {!loading ? (
          <h3>
            {pixel.current?.result?.facebook_access_token
              ? localeText("editIntegrationConfig")
              : localeText("integrationConfig")}
          </h3>
        ) : null}

        <div className="flex flex-column gap-4">
          <div className="flex flex-column">
            <label htmlFor="access">{localeText("accessToken")}</label>
            <InputText
              ref={accessTokenInput}
              name="access"
              value={accessToken}
              onChange={(e) => setAccessToken(e.target.value)}
              onBlur={() => {
                if (accessToken === "" || !accessToken) {
                  accessTokenInput.current.style.border = "1px solid red";
                }
              }}
              onFocus={() => {
                accessTokenInput.current.style.border = "1px solid #ced4da";
              }}
            />
          </div>
          <div className="flex flex-column">
            <label htmlFor="pixel">{localeText("pixelNumberId")}</label>
            <InputText
              ref={pixelIdInput}
              name="pixel"
              value={pixelId}
              onChange={(e) => setPixelId(e.target.value)}
              onBlur={() => {
                if (pixelId === "" || !pixelId) {
                  pixelIdInput.current.style.border = "1px solid red";
                }
              }}
              onFocus={() => {
                pixelIdInput.current.style.border = "1px solid #ced4da";
              }}
            />
          </div>
          <div>
            <Button
              onClick={() => configPixel(accessToken, pixelId)}
              label={localeText("savePixelConfig")}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default MetaAdsConfig;
